/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BudgetTeamInCompanyInTokenDto
 */
export interface BudgetTeamInCompanyInTokenDto {
    /**
     * 
     * @type {string}
     * @memberof BudgetTeamInCompanyInTokenDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof BudgetTeamInCompanyInTokenDto
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof BudgetTeamInCompanyInTokenDto
     */
    budgetName: string;
}

/**
 * Check if a given object implements the BudgetTeamInCompanyInTokenDto interface.
 */
export function instanceOfBudgetTeamInCompanyInTokenDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "teamName" in value;
    isInstance = isInstance && "budgetName" in value;

    return isInstance;
}

export function BudgetTeamInCompanyInTokenDtoFromJSON(json: any): BudgetTeamInCompanyInTokenDto {
    return BudgetTeamInCompanyInTokenDtoFromJSONTyped(json, false);
}

export function BudgetTeamInCompanyInTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetTeamInCompanyInTokenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'teamName': json['teamName'],
        'budgetName': json['budgetName'],
    };
}

export function BudgetTeamInCompanyInTokenDtoToJSON(value?: BudgetTeamInCompanyInTokenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'teamName': value.teamName,
        'budgetName': value.budgetName,
    };
}

